import { render, staticRenderFns } from "./ColumnGroups.vue?vue&type=template&id=754c9827"
import script from "./ColumnGroups.vue?vue&type=script&lang=js"
export * from "./ColumnGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports